import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "base-select" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import Dropdown from "primevue/dropdown";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-select',
  props: {
    options: {},
    width: { default: "100%" },
    height: { default: "2.75rem" },
    radius: { default: "6px" },
    background: { default: "#fff" },
    placeholder: {},
    value: {},
    isEmpty: { type: Boolean, default: true },
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v3913d597": (_ctx.width),
  "v60d03914": (_ctx.height),
  "v3f24823e": (_ctx.radius),
  "v0957e7fd": (_ctx.background)
}))

const { t } = useI18n();

const emit = __emit;

const props = __props;

const internalValue = ref<string | number | null>(null);

const internalOptions = computed(() => {
  const optionEmpty = {
    label: t("common.placeholders.select"),
    value: "empty",
  };

  const optionsFormatted = (props.options || []).map((item) => ({
    label: item.option,
    value: item.value,
  }));

  return props.isEmpty ? [optionEmpty, ...optionsFormatted] : optionsFormatted;
});

function update(data: { originalEvent: Event; value: any }) {
  internalValue.value = data.value === "empty" ? null : data.value;
  emit("update:modelValue", internalValue.value);
  emit("change", internalValue.value);
}

watchEffect(() => {
  if (props.value !== undefined) internalValue.value = props.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { error: _ctx.$slots.error }])
    }, [
      (!__props.loading)
        ? (_openBlock(), _createBlock(_unref(Dropdown), _mergeProps({
            key: 0,
            class: "custom-dropdown"
          }, _ctx.$attrs, {
            modelValue: internalValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
            options: internalOptions.value,
            optionLabel: "label",
            optionValue: "value",
            placeholder: 
          __props.placeholder ? __props.placeholder : _unref(t)('common.placeholders.select')
        ,
            disabled: __props.disabled,
            onChange: update
          }), null, 16, ["modelValue", "options", "placeholder", "disabled"]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.$slots.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "error")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})